import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { WorkflowRunStep } from 'dashboard/models/workflow-step';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiModel, ApiResponse } from 'lib/interfaces/api';

const api = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    getExternalWorkflowStep: builder.query<ApiResponse<WorkflowRunStep>, string>({
      query: async (workflowRunStepId) =>
        await SessionClientDashboard.getResource<WorkflowRunStep>(
          ApiEndpoint.WorkflowRunStep,
          workflowRunStepId,
        ),
      providesTags: (result, _error, _id) =>
        result ? [{ type: ApiModel.WorkflowRunStep, id: result.data.id }] : [],
    }),
  }),
});

export const { useGetExternalWorkflowStepQuery } = api;
